<div class="merchant-container">
    <app-projects-simple-section-viewer [sectionType]="'ACCOUNT'"></app-projects-simple-section-viewer>
    <div bdFxLayoutAlign="center center" class="project-number">
        Projekt-ID: {{model.project.sapProjectId}}
    </div>
</div>
